import * as React from 'react';
import { TPAComponentProps } from '../../types';

export interface ActionsMenuLayoutProps extends TPAComponentProps {
  children: React.ReactNode | React.ReactNode[];
  alignment?: ActionsMenuLayoutItemAlignment;
  /**
   * Provide item index which will be focused on initial render.
   * If prop is not provided, no item will be autofocused
   */
  focusedIndex?: number;
  /** a11y */
  'aria-labeledby'?: string;
  'aria-label'?: string;
}

export interface ActionsMenuLayoutLiRefs {
  [key: number]: {
    liRef: React.RefObject<HTMLLIElement>;
  };
}

export enum ActionsMenuLayoutDataHooks {
  mobile = 'data-mobile',
}
export interface ActionsMenuLayoutItemProps extends TPAComponentProps {
  prefixIcon?: React.ReactNode;
  /** the item's content */
  content: string;
  /** the subtitle of the item */
  subtitle?: string;
  disabled?: boolean;
  onClick(): void;
  alignment?: ActionsMenuLayoutItemAlignment;
  /** a11y */
  'aria-label'?: string;
}

export enum ActionsMenuLayoutItemAlignment {
  left = 'left',
  center = 'center',
  right = 'right',
}

export interface ActionsMenuLayoutState {
  focusedIdx: number;
}
